<template>
  <section class="section">
    <div class="container is-fluid">
      <h1 class="title has-text-centered">Projects</h1>
      <div class="tile is-ancestor">
        <div class="tile is-parent" v-for="(project, i) in projects" :key="i">
          <a
            class="project-link tile is-child notification is-link box"
            @click.prevent="gotoProject($store.state.auth.user.groups[0].id, $store.state.auth.user.id, project.id)"
          >{{project.name}}</a>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { CourseClient } from "../clients/CourseClient";
import BaseHelper from "../helpers/BaseHelper";

export default {
  name: "Projects",
  data: function() {
    return {
      projects: null,
      user: null,
      groupId: null
    };
  },
  mixins: [BaseHelper],

  methods: {
    getProjects() {
      CourseClient.getProjects()
        .then(result => {
          this.projects = result.data.projects;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.getProjects();
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/variables";
@import "../assets/scss/projects/projects.scss";
</style>
